import escapeRope1 from "@/assets/sprites/items/consumables/escape-rope-1.svg";
import escapeRope2 from "@/assets/sprites/items/consumables/escape-rope-2.svg";
import escapeRope3 from "@/assets/sprites/items/consumables/escape-rope-3.svg";
import potionAttack from "@/assets/sprites/items/consumables/attack-potion.svg";
import potionDefense from "@/assets/sprites/items/consumables/defense-potion.svg";
import potionHaste from "@/assets/sprites/items/consumables/haste-potion.svg";
import potionHp from "@/assets/sprites/items/consumables/hp-potion.svg";
import potionLuck from "@/assets/sprites/items/consumables/luck-potion.svg";
import potionSpAttack from "@/assets/sprites/items/consumables/sp-attack-potion.svg";
import potionSpDefense from "@/assets/sprites/items/consumables/sp-defense-potion.svg";
import potionSpeed from "@/assets/sprites/items/consumables/speed-potion.svg";
import potionStamina from "@/assets/sprites/items/consumables/stamina-potion.svg";
import potionMystery from "@/assets/sprites/items/consumables/mystery-potion.svg";
import potionAttack2 from "@/assets/sprites/items/consumables/attack-potion-2.svg";
import potionDefense2 from "@/assets/sprites/items/consumables/defense-potion-2.svg";
import potionHaste2 from "@/assets/sprites/items/consumables/haste-potion-2.svg";
import potionHp2 from "@/assets/sprites/items/consumables/hp-potion-2.svg";
import potionLuck2 from "@/assets/sprites/items/consumables/luck-potion-2.svg";
import potionSpAttack2 from "@/assets/sprites/items/consumables/sp-attack-potion-2.svg";
import potionSpDefense2 from "@/assets/sprites/items/consumables/sp-defense-potion-2.svg";
import potionSpeed2 from "@/assets/sprites/items/consumables/speed-potion-2.svg";
import potionStamina2 from "@/assets/sprites/items/consumables/stamina-potion-2.svg";
import fishArcaneAxolotl from "@/assets/sprites/items/fish/arcane-axolotl.svg";
import fishBulwarkBarnacle from "@/assets/sprites/items/fish/bulwark-barnacle.svg";
import fishCleansingClam from "@/assets/sprites/items/fish/cleansing-clam.svg";
import fishEnduringEel from "@/assets/sprites/items/fish/enduring-eel.svg";
import fishFortunateFlounder from "@/assets/sprites/items/fish/fortunate-flounder.svg";
import fishHeartyHalibut from "@/assets/sprites/items/fish/hearty-halibut.svg";
import fishQuickQuillfish from "@/assets/sprites/items/fish/quick-quillfish.svg";
import fishSavageSawfish from "@/assets/sprites/items/fish/savage-sawfish.svg";
import gearBoots from "@/assets/sprites/items/gear/boots.svg";
import gearChestplate from "@/assets/sprites/items/gear/chestplate.svg";
import gearHelmet from "@/assets/sprites/items/gear/helmet.svg";
import gearLeggings from "@/assets/sprites/items/gear/leggings.svg";
import gearShamanRing from "@/assets/sprites/items/gear/shaman-ring.svg";
import gearSuctionCups from "@/assets/sprites/items/gear/suction-cups.svg";
import gearSword from "@/assets/sprites/items/gear/sword.svg";
import gearBoots2 from "@/assets/sprites/items/gear/boots-2.svg";
import gearChestplate2 from "@/assets/sprites/items/gear/chestplate-2.svg";
import gearHelmet2 from "@/assets/sprites/items/gear/helmet-2.svg";
import gearLeggings2 from "@/assets/sprites/items/gear/leggings-2.svg";
import gearSword2 from "@/assets/sprites/items/gear/sword-2.svg";
import gearBoots3 from "@/assets/sprites/items/gear/boots-3.svg";
import gearChestplate3 from "@/assets/sprites/items/gear/chestplate-3.svg";
import gearHelmet3 from "@/assets/sprites/items/gear/helmet-3.svg";
import gearLeggings3 from "@/assets/sprites/items/gear/leggings-3.svg";
import gearSword3 from "@/assets/sprites/items/gear/sword-3.svg";
import gearBoots4 from "@/assets/sprites/items/gear/boots-4.svg";
import gearChestplate4 from "@/assets/sprites/items/gear/chestplate-4.svg";
import gearHelmet4 from "@/assets/sprites/items/gear/helmet-4.svg";
import gearLeggings4 from "@/assets/sprites/items/gear/leggings-4.svg";
import gearSword4 from "@/assets/sprites/items/gear/sword-4.svg";
import gearHeavySword from "@/assets/sprites/items/gear/heavy-sword.svg";
import gearHeavySword2 from "@/assets/sprites/items/gear/heavy-sword-2.svg";
import gearHeavySword3 from "@/assets/sprites/items/gear/heavy-sword-3.svg";
import gearHeavySword4 from "@/assets/sprites/items/gear/heavy-sword-4.svg";
import gearBurstStaff from "@/assets/sprites/items/gear/burst-staff.svg";
import gearBurstStaff2 from "@/assets/sprites/items/gear/burst-staff-2.svg";
import gearBurstStaff3 from "@/assets/sprites/items/gear/burst-staff-3.svg";
import gearBurstStaff4 from "@/assets/sprites/items/gear/burst-staff-4.svg";
import gearRapidStaff from "@/assets/sprites/items/gear/rapid-staff.svg";
import gearRapidStaff2 from "@/assets/sprites/items/gear/rapid-staff-2.svg";
import gearRapidStaff3 from "@/assets/sprites/items/gear/rapid-staff-3.svg";
import gearRapidStaff4 from "@/assets/sprites/items/gear/rapid-staff-4.svg";
import gearTrident from "@/assets/sprites/items/gear/trident.svg";
import gearUndeadGem from "@/assets/sprites/items/gear/undead-gem.svg";
import bestiary from "@/assets/sprites/items/key-items/bestiary.svg";
import fishingRod from "@/assets/sprites/items/key-items/fishing-rod.svg";
import loweringRope from "@/assets/sprites/items/key-items/lowering-rope.svg";
import questScroll from "@/assets/sprites/items/key-items/quest-scroll.svg";
import antChitin from "@/assets/sprites/items/materials/ant-chitin.svg";
import inkSac from "@/assets/sprites/items/materials/ink-sac.svg";
import fireAlligatorHide from "@/assets/sprites/items/materials/fire-alligator-hide.svg";
import ratPelt from "@/assets/sprites/items/materials/rat-pelt.svg";
import clay from "@/assets/sprites/items/materials/clay.svg";
import driftwood from "@/assets/sprites/items/materials/driftwood.svg";
import rottenTentacle from "@/assets/sprites/items/materials/rotten-tentacle.svg";
import seaweed from "@/assets/sprites/items/materials/seaweed.svg";
import magicBait from "@/assets/sprites/items/materials/magic-bait.svg";
import blacksmithHammer from "@/assets/sprites/items/key-items/blacksmith-hammer.svg";
import pickaxe from "@/assets/sprites/items/key-items/pickaxe.svg";
import blacksmithHealingPotion from "@/assets/sprites/items/consumables/blacksmith-healing-potion.svg";
import inventorySlotsUpgrade from "@/assets/sprites/items/upgrades/inventory-slots.svg";
import stackSizeUpgrade from "@/assets/sprites/items/upgrades/stack-size.svg";
import rustyMetal from "@/assets/sprites/items/materials/rusty-metal.svg";
import rustyGear from "@/assets/sprites/items/materials/rusty-gear.svg";
import towerKey from "@/assets/sprites/items/key-items/tower-key.svg";
import blacksmithBlueprints from "@/assets/sprites/items/key-items/blacksmith-blueprints.svg";
import craftingTable from "@/assets/sprites/items/key-items/crafting-table.svg";
import mapmakerChalk from "@/assets/sprites/items/consumables/mapmaker-chalk.svg";
import tackleBox from "@/assets/sprites/items/key-items/tackle-box.svg";
import eyeOfFrog from "@/assets/sprites/items/materials/eye-of-frog.svg";
import mutatedRatTail from "@/assets/sprites/items/materials/mutated-rat-tail.svg";
import fireAntChitin from "@/assets/sprites/items/materials/fire-ant-chitin.svg";

export const itemSprites = {
  antChitin, bestiary, escapeRope1, escapeRope2, escapeRope3, fishingRod,
  fishArcaneAxolotl, fishBulwarkBarnacle, fishCleansingClam, fishEnduringEel,
  fishFortunateFlounder, fishHeartyHalibut, fishQuickQuillfish, fishSavageSawfish,
  gearBoots, gearChestplate, gearHelmet, gearLeggings, gearShamanRing, gearSuctionCups, gearSword,
  gearBoots2, gearChestplate2, gearHelmet2, gearLeggings2, gearSword2,
  gearBoots3, gearChestplate3, gearHelmet3, gearLeggings3, gearSword3,
  gearBoots4, gearChestplate4, gearHelmet4, gearLeggings4, gearSword4,
  gearHeavySword, gearHeavySword2, gearHeavySword3, gearHeavySword4,
  gearBurstStaff, gearBurstStaff2, gearBurstStaff3, gearBurstStaff4,
  gearRapidStaff, gearRapidStaff2, gearRapidStaff3, gearRapidStaff4,
  gearTrident, gearUndeadGem, inkSac, fireAlligatorHide, loweringRope, potionAttack, potionDefense,
  potionHaste, potionHp, potionLuck, potionMystery, potionSpAttack, potionSpDefense, potionSpeed,
  potionStamina, potionAttack2, potionDefense2, potionHaste2, potionHp2, potionLuck2,
  potionSpAttack2, potionSpDefense2, potionSpeed2, potionStamina2,
  questScroll, ratPelt, clay, driftwood, rottenTentacle, seaweed, magicBait,
  blacksmithHammer, pickaxe, blacksmithHealingPotion,
  inventorySlotsUpgrade, stackSizeUpgrade,
  rustyMetal, rustyGear, towerKey, blacksmithBlueprints, craftingTable, mapmakerChalk, tackleBox,
  eyeOfFrog, mutatedRatTail, fireAntChitin,
} as const;
